import JsxHelper from '../../../Helpers/JsxHelper';
import React from 'react';
import RedirectLinkComponent from '../../../Elements/RedirectLinkComponent';
import FieldTypesEnum from '../../../Enums/FieldTypesEnum';
import TabListTableCellWidthEnum from '../../../Enums/TabListTableCellWidthEnum';
import DataTableActionMenu from '../../../Elements/DataTable/DataTableActionMenu';
import AuthService from '../../../Services/authService';
import AssignmentPaymentDetails from '../../../Contents/Evaluator/EvaluatorAdmin/EvaluatorPayments/AssignmentPaymentDetails';
import RoleService from '../../../Services/roleService';
import EvaluatorPaymentApproveHelper from '../../../Helpers/ModelHelpers/EvaluatorPaymentApproveHelper';
import LookupText from '../../../Elements/LookupText';
import UserNameComponent from '../../../Elements/UserNameComponent';

export default class ThirdPartyJobPaymentsItem {
  constructor(item) {
    this.initialize(item);
    this.Selected = false;
  }

  async initialize(item) {
    this.TpEvaluatorTpJobPaymentId = item.tpEvaluatorTpJobPaymentId;
    this.TpJobId = item.tpJobId;
    this.TpEvaluatorId = item.tpEvaluatorId;
    this.Comment = item.comment;
    this.ExportId = item.exportId;
    this.ExportPaymentId = item.exportPaymentId;
    this.CheckId = item.checkId;
    this.EvaluatorPaymentOfficeId = item.evaluatorPaymentOfficeId;
    this.AssignedOnUtc = item.assignedOnUtc;
    this.AssignedTo = item.assignedTo;
    this.SubmittedOnUtc = item.submittedOnUtc;
    this.SubmittedBy = item.submittedBy;
    this.ApprovedOnUtc = item.approvedOnUtc;
    this.ApprovedBy = item.approvedBy;
    this.StatusCodeLookupValue = item.statusCodeLookupValue;
    this.TypeText = item.typeText;
    this.ReissuedFromTpEvaluatorTpJobPaymentId = item.reissuedFromTpEvaluatorTpJobPaymentId;
    this.VoidReason = item.voidReason;
    this.ClientName = item.clientName == null ? '' : item.clientName;
    this.EvaluatorName = item.evaluatorName == null ? '' : item.evaluatorName;
    this.PaymentTypeText = item.paymentTypeText;
    this.CreatedBy = item.createdBy;
    this.CreatedOnUtc = item.createdOnUtc;
    this.ModifiedBy = item.modifiedBy;
    this.ModifiedOnUtc = item.modifiedOnUtc;
    this.ThirdPartyJobId = item.thirdPartyJobId;
    // CD-5421: from the related TpJob - the shop was paid to the evaluator outside Bravo.
    this.PaidOutsideOfSystem = item.paidOutsideOfSystem;
    this.Fee = item.fee;
    this.FeeAdjustment = item.feeAdjustment;
    this.Expense = item.expense;
    this.Vat = item.vat;
    this.Total = item.total;
    this.TotalDisplay = item.totalDisplay;
    this.Paid = item.paid;
    this.PaidDisplay = item.paidDisplay;
    this.Due = item.due;
    this.CreatedOnUtc = item.createdOnUtc;
    this.EvaluatorCurrencyCode = item.evaluatorCurrencyCode;
    this.EvaluatorCurrencySymbol = item.evaluatorCurrencySymbol;
    this.EvaluatorCurrencyId = item.evaluatorCurrencyId;
    this.ThirdPartyLocationName = item.thirdPartyLocationName;
    this.EvaluatorOfficeName = item.evaluatorOfficeName;
    this.PaymentDate = item.paymentDate == null ? '' : item.paymentDate;
    this.ReissuedToTpEvaluatorTpJobPaymentId = item.reissuedToTpEvaluatorTpJobPaymentId;
    this.ReissuedFromTpEvaluatorTpJobPaymentId = item.reissuedFromTpEvaluatorTpJobPaymentId;
    this.Reimbursement = item.reimbursement;
    this.Misc = item.misc;
    this.Travel = item.travel;
    this.Gaming = item.gaming;
    this.FeeDisplay = item.feeDisplay;
    this.ProjectId = item.projectId == null ? '' : item.projectId;
    this.ProjectName = item.projectName == null ? '' : item.projectName;
    this.ProjectIdAndName = this.ProjectId === '' ? '' : `${this.ProjectId} - ${this.ProjectName}`;
    this.JobDate = item.jobDate;
    this.ThirdPartyLocationCountry = item.thirdPartyLocationCountry;
    this.FieldworkOfficeId = item.fieldworkOfficeId;
    this.FieldworkOfficeName = item.fieldworkOfficeName;
    this.InfoRequested = item.infoRequested;
  }

  static NameOfTheIdField() {
    return 'TpEvaluatorTpJobPaymentId';
  }
  static nameOfTheItemDetailList() {
    return 'Evaluator Payment';
  }

  static MoneyFields = [
    'Fee',
    'FeeAdjustment',
    'Expense',
    'Total',
    'Vat',
    'Paid',
    'Due',
    'Reimbursement',
    'Gaming',
    'Travel',
    'Misc',
    'TotalDisplay',
    'PaidDisplay',
    'FeeDisplay',
  ];

  static Currency() {
    return 'EvaluatorCurrencyCode';
  }

  static MoneyFieldsSecondary = [];

  static CurrencySecondary() {
    return '';
  }

  static DateOnlyFields = ['JobDate'];

  static DateFields = ['CreatedOnUtc', 'ApprovedOnUtc', 'PaymentDate', 'JobDate', 'SubmittedOnUtc'];

  static BoolFields = [];

  static idFunction(item) {
    if (item.ThirdPartyJobId == null) {
      return '';
    }
    // CD-5483: no link to the TP Jobs page for a user who cannot open it, such as one with only an approver role.
    if (!RoleService.CheckUserPermission('submenu', 'operations_thirdpartyjobs')) {
      return item.ThirdPartyJobId;
    }
    return (
      <RedirectLinkComponent
        path='tpjobs'
        tooltipText={item.ThirdPartyJobId}
        text={item.ThirdPartyJobId}
        keyValuePairs={[{ key: 'ThirdPartyJobId', value: item.ThirdPartyJobId }]}
      />
    );
  }

  static FieldsToShowInDataTable() {
    return [
      {
        label: 'Third-Party Job ID',
        orderById: 'ThirdPartyJobId',
        data: 'ThirdPartyJobId',
        type: FieldTypesEnum.DataFieldWithDetails,
        minWidth: 70,
      },
      {
        label: ThirdPartyJobPaymentsItem.getSelectedCellHeader,
        orderById: '',
        data: ThirdPartyJobPaymentsItem.getSelectedCellContent,
        type: FieldTypesEnum.PureDataField,
        minWidth: 10,
      },
      { label: 'Export', orderById: 'ExportId', data: 'ExportId', minWidth: 50 },
      { label: 'Type', orderById: 'TypeText', data: 'TypeText', minWidth: 50 },
      {
        label: 'Status',
        orderById: 'Status',
        data: (item) => (
          <LookupText
            lookupId={45}
            value={item.StatusCodeLookupValue}
          />
        ),
        minWidth: 50,
      },
      // CD-5421: sits directly after Status on purpose - it is what explains a Closed payment.
      {
        label: 'Paid Outside of System',
        orderById: 'PaidOutsideOfSystem',
        data: (item) => JsxHelper.YesNo(item.PaidOutsideOfSystem),
        minWidth: 20,
      },
      { label: 'Method', orderById: 'PaymentTypeText', data: 'PaymentTypeText', minWidth: 50 },
      { label: 'Fee', orderById: 'FeeDisplay', data: 'FeeDisplay', minWidth: 50 },
      { label: 'Fee Addit.', orderById: 'FeeAdjustment', data: 'FeeAdjustment', minWidth: 50 },
      { label: 'Expenses', orderById: 'Expense', data: 'Expense', minWidth: 50 },
      { label: 'Total', orderById: 'TotalDisplay', data: 'TotalDisplay', minWidth: 50 },
      { label: 'Tax', orderById: 'Vat', data: 'Vat', minWidth: 50 },
      { label: 'Paid', orderById: 'PaidDisplay', data: 'PaidDisplay', minWidth: 50 },
      { label: 'Due', orderById: 'Due', data: 'Due', minWidth: 50 },
      { label: 'Payment Export Date', orderById: 'PaymentDate', data: 'PaymentDate', minWidth: 50 },
      { label: 'Created On', orderById: 'CreatedOnUtc', data: 'CreatedOnUtc', minWidth: 50 },
      { label: 'Approved On', orderById: 'ApprovedOnUtc', data: 'ApprovedOnUtc', minWidth: 50 },
      {
        label: ' ',
        orderById: '',
        data: ThirdPartyJobPaymentsItem.getActionCellContent,
        type: FieldTypesEnum.ActionButton,
        minWidth: 50,
      },
    ];
  }

  static getSelectedCellContent(item) {
    return (
      <input
        type='checkbox'
        checked={item.Selected}
        onChange={(e) => {
          ThirdPartyJobPaymentsItem.clickOnSelect(item, e.target.checked);
        }}
      />
    );
  }

  static clickOnGlobalSelect(item, selected) {
    // Placeholder, don't remove it!
  }

  static selectedStatus() {
    return false;
  }

  static getSelectedCellHeader(item) {
    return (
      <input
        type='checkbox'
        checked={ThirdPartyJobPaymentsItem.selectedStatus()}
        onChange={(e) => {
          ThirdPartyJobPaymentsItem.clickOnGlobalSelect(item, e.target.checked);
        }}
      />
    );
  }

  static clickOnSelect(item, selected) {
    // Placeholder, don't remove it!
  }

  static actionFunction(ids, actionType) {
    // Placeholder, don't remove it!
  }

  static statusChangeFunction = (item) => {
    // Placeholder, don't remove it!
  };

  static getActionCellContent(item) {
    // CD-5421: 17 is Paid Outside of System. It is a closed state for every gate below, exactly as 10
    // (Closed) is - it replaced the old (Closed + TpJob.PaidOutsideOfSystem) pair.
    const alwaysDisabledStatuses = [10, 17, 13, 14, 15, 16, 6];
    const userId = AuthService.getInstance().GetLoggedInUser().userId.toString();

    const isPaymentRequestType = item.TypeText === 'Payment Request';
    const isAdvancePaymentType = item.TypeText === 'Advance Payment';
    const isAssignmentPaymentType = item.TypeText === 'Assignment Payment';
    const isClosedStatus = [10, 17].includes(item.StatusCodeLookupValue);
    const isReconciledStatus = item.StatusCodeLookupValue === 5;
    const isCreatedStatus = item.StatusCodeLookupValue === 1;
    const isApprovedStatus = item.StatusCodeLookupValue === 2;
    const isVoidStatus = item.StatusCodeLookupValue === 6;
    const isPendingStatus = item.StatusCodeLookupValue === 4;
    const isSuppressedStatus = item.StatusCodeLookupValue === 7;

    return (
      <DataTableActionMenu
        options={[
          {
            text: `Assignment Payment (${item.TpEvaluatorTpJobPaymentId})`,
            link: <AssignmentPaymentDetails id={item.TpEvaluatorTpJobPaymentId} />,
            iconName: 'fa-solid fa-circle-info',
            // CD-5483: DataTableActionMenu ignores a link option's roleKey, so it is checked here, which keeps the link from
            // the approver roles and EvaluatorPaymentView. It reads a legacy payment by this third-party id, which is wrong
            // for everyone.
            hide:
              item.TypeText !== 'Surcharge' ||
              !RoleService.CheckUserPermission('faicon', 'EvaluatorPayment_ActionButton'),
            url: 'paymentdetails',
            roleKey: 'EvaluatorPayment_ActionButton',
          },
          {
            text: 'Approve',
            onClick: () => ThirdPartyJobPaymentsItem.actionFunction([item.TpEvaluatorTpJobPaymentId], 'Approve'),
            iconName: 'fa-solid fa-check',
            // Mirrors the server's allow-list in TpEvaluatorTpJobPaymentRepository.ValidateApprovePaymentAsync: Created (1)
            // on a non-payment-request, Pending Approval (8) on a payment request, and an Assignment Payment at Pending
            // Approval by Supervisor (11). The deny-list this replaced offered Paid (3), Info Required (9), Info Required by
            // Supervisor (12) and a payment request at Created, which the server always refused.
            disabled:
              !(
                (item.StatusCodeLookupValue === 1 && !isPaymentRequestType) ||
                (item.StatusCodeLookupValue === 8 && isPaymentRequestType) ||
                (item.StatusCodeLookupValue === 11 && isAssignmentPaymentType)
              ) || !EvaluatorPaymentApproveHelper.IsOpenToUser(item.StatusCodeLookupValue, item.TypeText),
            hide: isAdvancePaymentType,
            roleKey: 'EvaluatorPayment_Approve_ActionButton',
          },
          {
            text: 'Void',
            onClick: () => ThirdPartyJobPaymentsItem.actionFunction([item.TpEvaluatorTpJobPaymentId], 'Void'),
            iconName: 'fa-solid fa-xmark',
            disabled:
              (!isPaymentRequestType && alwaysDisabledStatuses.includes(item.StatusCodeLookupValue)) ||
              (isPaymentRequestType && isVoidStatus && isSuppressedStatus),
            roleKey: 'EvaluatorPayment_ActionButton',
          },
          {
            text: 'Void and Reissue',
            onClick: () => ThirdPartyJobPaymentsItem.actionFunction([item.TpEvaluatorTpJobPaymentId], 'VoidAndReissue'),
            iconName: 'fa-solid fa-rotate-right',
            disabled:
              alwaysDisabledStatuses.includes(item.StatusCodeLookupValue) ||
              [7].includes(item.StatusCodeLookupValue) ||
              isPaymentRequestType ||
              isAdvancePaymentType,
            hide: isAdvancePaymentType && !isVoidStatus && !isApprovedStatus && !isPendingStatus && !isReconciledStatus,
            roleKey: 'EvaluatorPayment_ActionButton',
          },
          {
            text: 'Void and Supress',
            onClick: () => ThirdPartyJobPaymentsItem.actionFunction([item.TpEvaluatorTpJobPaymentId], 'VoidAndSupress'),
            iconName: 'fa-solid fa-trash',
            disabled:
              alwaysDisabledStatuses.includes(item.StatusCodeLookupValue) ||
              [7].includes(item.StatusCodeLookupValue) ||
              isPaymentRequestType,
            roleKey: 'EvaluatorPayment_ActionButton',
          },
          {
            text: 'Reissue',
            onClick: () => ThirdPartyJobPaymentsItem.actionFunction([item.TpEvaluatorTpJobPaymentId], 'VoidAndReissue'),
            iconName: 'fa-solid fa-rotate-right',
            disabled: item.ReissuedToTpEvaluatorTpJobPaymentId !== null && ![6, 7].includes(item.StatusCodeLookupValue),
            hide: (!isAdvancePaymentType && ![6, 7].includes(item.StatusCodeLookupValue)) || isAdvancePaymentType,
            roleKey: 'EvaluatorPayment_ActionButton',
          },
          {
            iconName: 'fa-solid fa-edit',
            disabled:
              (((!isPaymentRequestType && !isCreatedStatus) ||
                (isPaymentRequestType && (isClosedStatus || isReconciledStatus))) &&
                !isAdvancePaymentType &&
                (isClosedStatus || isReconciledStatus)) ||
              (isAssignmentPaymentType && !isCreatedStatus && !isApprovedStatus),
            roleKey: 'EvaluatorPayment_ActionButton',
            text: 'Edit',
            onClick: () => ThirdPartyJobPaymentsItem.editFunction(item),
          },
          {
            text: 'Status Change',
            onClick: () => ThirdPartyJobPaymentsItem.statusChangeFunction(item),
            iconName: 'fa-solid fa-rotate-right',
            disabled:
              isApprovedStatus ||
              isClosedStatus ||
              isReconciledStatus ||
              isVoidStatus ||
              (item.CreatedBy?.toString() !== userId?.toString() &&
                item.AssignedTo?.toString() !== userId?.toString() &&
                !AuthService.IsAdmin()),
            hide: !isPaymentRequestType && !isAdvancePaymentType,
            roleKey: 'EvaluatorPayment_ActionButton',
          },
        ]}
      />
    );
  }

  static FieldsToShowInListTable = [
    {
      tabName: 'Info',
      tabLabel: 'Info',
      icon: 'fa-solid fa-info',
      data: [
        { label: 'Type', name: 'TypeText' },
        {
          label: 'Status',
          name: (item) => (
            <LookupText
              lookupId={45}
              value={item.StatusCodeLookupValue}
            />
          ),
        },
        { label: 'Paid Outside of System', name: (item) => JsxHelper.YesNo(item.PaidOutsideOfSystem) },
        { label: 'Third-Party Job', name: ThirdPartyJobPaymentsItem.idFunction },
        { label: 'Pay ID', name: 'TpEvaluatorTpJobPaymentId' },
        { label: 'Location', name: 'ThirdPartyLocationName' },
        { label: 'Evaluator', name: 'EvaluatorName' },
        { label: 'Payment Office', name: 'EvaluatorOfficeName' },
        { label: 'Currency', name: 'EvaluatorCurrencyCode' },
        { label: 'Payment Method', name: 'PaymentTypeText' },
        { label: 'Payment Export Date', name: 'PaymentDate' },
        { label: 'Approved On', name: 'ApprovedOnUtc' },
        { label: 'Created By', name: (item) => <UserNameComponent userId={item.CreatedBy} /> },
        { label: 'Assigned To', name: (item) => <UserNameComponent userId={item.AssignedTo} /> },
        { label: 'Submitted On', name: 'SubmittedOnUtc' },
        { label: 'Approved By', name: (item) => <UserNameComponent userId={item.ApprovedBy} /> },
        { label: 'Reprinted As', name: 'ReissuedToTpEvaluatorTpJobPaymentId' },
        { label: 'Reprinted From', name: 'ReissuedFromTpEvaluatorTpJobPaymentId' },
        { label: 'Void Reason', name: 'VoidReason', width: TabListTableCellWidthEnum.TwoLines },
        { label: 'Comment', name: 'Comment', width: TabListTableCellWidthEnum.TwoLines },
        { label: 'Fees', name: '-' },
        { label: 'Fee', name: 'FeeDisplay' },
        { label: 'Additional Fee', name: 'FeeAdjustment' },
        { label: 'Initial Total', name: 'TotalDisplay' },
        { label: 'Reimbursement', name: 'Reimbursement' },
        { label: 'Misc', name: 'Misc' },
        { label: 'Tax', name: 'Vat' },
        { label: 'Travel', name: 'Travel' },
        { label: 'Paid', name: 'PaidDisplay' },
        { label: 'Gaming', name: 'Gaming' },
        { label: 'Current Total Due', name: 'Due' },
        { label: 'Export', name: '-' },
        { label: 'Export Payment', name: 'ExportPaymentId' },
        { label: 'Export', name: 'ExportId' },
      ],
    },
  ];

  static editFunction = (item) => {
    // Placeholder, don't remove it!
  };
}
